import { render } from "./IndexConfig.vue?vue&type=template&id=4f4e73a1"
import script from "./IndexConfig.vue?vue&type=script&lang=js"
export * from "./IndexConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__